import _ from 'lodash';
import { v4 as uuid } from 'uuid';

import { FieldProps } from '@breathelife/ui-components';

export function ParticipantID(props: FieldProps): null {
  if (_.isEmpty(props.value)) {
    const newParticipantId = uuid();
    props.onAnswerChange(newParticipantId);
  }
  return null;
}
